export default __webpack_public_path__ + "static/media/arrow-pic.b8a1f3ca.png";